module.exports = __webpack_public_path__ + "static/media/thumbDefault.8fccd968.jpg";